import React, {useRef} from 'react';
import ReactDOM from 'react-dom';

export {default as ModalHeader} from './modalHeader';
export {default as ModalBody} from './modalBody';
export {default as ModalFooter} from './modalFooter';

export interface IModalProps {
  /**
   * Set additional styles
   */
  className?: string;
  /**
   * Set additional styles in the wrapper when is portal
   */
  wrapperClassName?: string;
  /**
   * Show close button and apply this function
   * @returns
   */
  onClose?: () => void;
  /**
   * Define if is visible or not when render as portal
   */
  open?: boolean;
  /**
   * Render with overlay in the screen
   */
  renderAsPortal?: boolean;
  [others: string]: any;
}

const Modal: React.FC<IModalProps> = (props) => {
  const {className, onClose, children, open, renderAsPortal, wrapperClassName, ...rest} = props;

  const modalRef = useRef<HTMLDivElement>(null);

  const iconClose = (
    <button
      type="button"
      data-testid={rest && rest['data-testid'] ? `${rest['data-testid']}-icon-close` : undefined}
      className="modal-close-button"
      onClick={onClose}
    >
      <span className="material-icons">close</span>
    </button>
  );

  const renderModal = () => {
    return (
      <div ref={modalRef} className={`modal ${className || ''}`} {...rest}>
        {typeof onClose === 'function' && iconClose}
        {children}
      </div>
    );
  };
  const content = <div className={`tag-ds modal-wrapper ${wrapperClassName || ''}`}>{renderModal()}</div>;

  if (renderAsPortal && typeof document !== 'undefined') {
    const container = document.getElementById('root') || document.body;
    return open ? ReactDOM.createPortal(content, container as Element) : null;
  }

  return renderModal();
};

export default Modal;
